import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";

// const debug = "TagsModule"
const debug = false

export class TagsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.TAGS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                        = "Tags"
        this.description                 = "Tags are a handy tool for organizing and categorizing tasks. Assign tags to tasks to quickly identify them by topic, status or priority, simplifying navigation and increasing teamwork efficiency."
        this.svgIcon                     = "isvg-tags"
        this.settingsUrl                 = "settings/tags"
        this.settingsMenuTopCategory     = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                   = "Core"

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}